export default {
    excess: 'Papildus saistības',
    security: 'Drošības nauda',
    fuel_policy: 'Degvielas politika',
    like_for_like: 'Patīk pret patīk',
    full_to_full: 'Pilns pret pilnu',
    mileage: 'Nobraukums: {mileage} jūdzes uz nomas reizi',
    unlimited_mileage: 'Neierobežots jūdžu skaits',
    non_refundable: 'Neatmaksājams',
    free_cancellation_until: 'Bezmaksas atcelšana līdz {date}',
    cancellation_with_terms: 'Atcelšana saskaņā ar {0} ',
    t_c_text: 'Noteikumus un nosacījumus',
    two_free_extras: 'Divas bezmaksas ekstras savācot transportlīdzekli',
    glass_tyres_covered: 'Stikls un riepas nosegtas'
}
